import React, { useEffect, useRef, useState } from 'react';
import { Link,useNavigate } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import Select from "react-select";
import Drawer from '@mui/material/Drawer';
import DatePicker, { DateObject } from "react-multi-date-picker";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';

import Absent from './../../../modal/hr_management/attendance/Absent';
import Permission from './../../../modal/hr_management/attendance/Permission';
import OD from './../../../modal/hr_management/attendance/od';
import Leave from './../../../modal/hr_management/attendance/Leave';
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { toast } from 'react-toastify';
import axios from 'axios';


const Add_Attendance = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const [staffOptions, setStaffOptions] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState(null);
    const [selectedStaffId, setSelectedStaffId] = useState(null);
    const [attendanceData, setAttendanceData] = useState([]);
    const [newAttendances, setNewAttendances] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();
    const tableRef = useRef(null);
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [filterOpen, setFilterOpen] = useState(false);
    const [currentStaffId, setCurrentStaffId] = useState(null);
    

    // useEffect(() => {
    // axios.get(`${baseURL}/managestaff`)
    //     .then((response) => {
    //         // console.log("Fetched staff data:", response.data.data);
    //         const options = response.data.data.map((staff) => ({
    //         id: staff.sno,
    //         name: staff.employee_name,
    //         department: staff.department?.department_name || '-',
    //         }));
    //         setStaffOptions(options);
    //     })
    //     .catch((error) => {
    //         console.error('Error fetching staff:', error);
    //         swal.fire('Error', 'Failed to fetch staff list.', 'error');
    //     });
    // }, []);

    useEffect(() => {
        axios.get(`${baseURL}/managestaff`, {params: {branch_id: branch_id}})
            .then((response) => {
                const options = response.data.data.map((staff) => ({
                    id: staff.sno,
                    name: staff.employee_name,
                    department: staff.department?.department_name || '-',
                })).sort((a, b) => a.name.localeCompare(b.name));
                setStaffOptions(options);

                // Initialize newAttendances with default "Present" (attendance_type: 0) for each staff
                // const defaultAttendances = options.map((staff) => ({
                //     manage_staff_id: staff.id,
                //     attendance_type: 0,
                //     date: new Date().toISOString().split('T')[0], // Current date
                // }));
                // setNewAttendances(defaultAttendances);
            })
            .catch((error) => {
                console.error('Error fetching staff:', error);
                swal.fire('Error', 'Failed to fetch staff list.', 'error');
            });
    }, []);

    // Fetch attendance data for the current month to check for scheduled leaves
    useEffect(() => {
        const currentDate = new Date();
        const month = currentDate.getMonth() + 1; // 1-based
        const year = currentDate.getFullYear();

        axios.post(`${baseURL}/manageattendance/monthandyear`, { month, year })
            .then(response => {
                if (response.data.success) {
                    setAttendanceData(response.data.data || []);
                }
            })
            .catch(error => {
                console.error('Error fetching attendance:', error);
                swal.fire('Error', 'Failed to fetch attendance data.', 'error');
            });
    }, []);

    useEffect(() => {
        axios.get(`${baseURL}/manageattendance`)
            .then(response => {
            // console.log("API response:", response.data);
            setAttendanceData(response.data.data);
            setHasFetched(true);
            })
            .catch(error => {
            console.error('There was an error fetching the posts!', error);
            setHasFetched(true);
            });
    }, []);
    

    // const handleModalToggle = () => {
    //     setModalType("Add");
    //     setOpen(true);
    // };
    
    const handleModalToggle_Edit = () => {
        setModalType("Edit");
        setOpen(true);
    };

    const handleModalPermission = () => {
        setModalType("Permission");
        setOpen(true);
    };
    const handleModalAbsent = () => {
        setModalType("Absent");
        setOpen(true);
    };
    const handleModalOD = () => {
        setModalType("OD");
        setOpen(true);
    };
    const handleModalLeave = () => {
        setModalType("Leave");
        setOpen(true);
    };

    const handleModalToggle = (type, staffId = null) => {
        setModalType(type);
        setCurrentStaffId(staffId);
        setOpen(true);
    };



    const onClose = () => {
        setFilterOpen(false);
    };


    const ConfirmationModal = () => {
        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, '0');
        const month = currentDate.toLocaleString('en-US', { month: 'short' });
        const year = currentDate.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        swal.fire({
            html: `
                          <div class="alert alert-success px-2 py-2" role="alert">
                              Are You Sure Want to Submit this Attendance
                              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                          </div>
                          <p class="text-center"><b>${formattedDate}</b></p>
                          <div class="text-center">
                              <svg xmlns="http://www.w3.org/2000/svg" 
                              // viewBox="0 0 48 48" width="48" height="48">
                              // <defs>
                              // <style>.cls-2{fill:#273941}.cls-5{fill:#f6fafd}
                              // </style></defs>
                              // <g id="_03-smile" data-name="03-smile"><circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                              // <path class="cls-2" d="M24 39c-7.168 0-13-4.935-13-11h2c0 4.962 4.935 9 11 9s11-4.038 11-9h2c0 6.065-5.832 11-13 11zM20 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6zM38 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6z"/>
                              // <path d="M24 4c12.15 0 22 8.507 22 19h.975a23 23 0 0 0-45.95 0H2C2 12.507 11.85 4 24 4z" style="fill:#ffe369"/>
                              // <path d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z" style="fill:#ffb32b"/>
                              // <ellipse class="cls-5" cx="37" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 37 9)"/>
                              // <ellipse class="cls-5" cx="30.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 30.745 4.5)"/>
                              // <ellipse class="cls-5" cx="34" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 34 7)"/></g>
                              // </svg>
                          </div>
                      `,
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        })
            .then(() => {
                window.location.href = './manage-attendance';
            });
    };

    useEffect(() => {
        if(staffOptions.length > 0){
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }}
    }, [staffOptions]);

    // Handle modal data submission
    const handleModalSubmit = (data) => {
        let attendanceEntry = {
            manage_staff_id: currentStaffId,
            attendance_type: data.attendance_type,
            branch_id: branch_id
        };

        switch (data.attendance_type) {
        case 0: // Present
            attendanceEntry.date = data.date;
            break;
        case 1: // Leave
            attendanceEntry.dates = data.dates;
            attendanceEntry.start_date = data.start_date || data.dates?.[0]; // or properly extract
            attendanceEntry.end_date = data.end_date || data.dates?.[data.dates.length - 1];
            attendanceEntry.leave_type = data.leave_type;
            attendanceEntry.reason = data.reason;
            break;
        case 2: // Permission
            attendanceEntry.future_permission = data.future_permission || 0;
            if (data.future_permission) {
            // attendanceEntry.dates = data.dates;
            attendanceEntry.dates = data.dates;
            attendanceEntry.start_times = data.start_times;
            attendanceEntry.end_times = data.end_times;
            } else {
            attendanceEntry.date = data.date;
            attendanceEntry.start_time = data.start_time;
            attendanceEntry.end_time = data.end_time;
            }
            attendanceEntry.permision_absent = data.permision_absent;
            attendanceEntry.reason = data.reason;
            break;
        case 3: // OD
            attendanceEntry.date = data.date;
            attendanceEntry.start_time = data.start_time;
            attendanceEntry.end_time = data.end_time;
            attendanceEntry.reason = data.reason;
            break;
        default:
            return;
        }

        setNewAttendances((prev) => {
            const existingIndex = prev.findIndex(
                (entry) => entry.manage_staff_id === currentStaffId
            );
            if (existingIndex >= 0) {
                return prev.map((entry, i) =>
                i === existingIndex ? attendanceEntry : entry
                );
            }
            return [...prev, attendanceEntry];
        });
        setOpen(false);
        setCurrentStaffId(null);
    };

    const getStaffAttendance = (staffId) => {
        return newAttendances.find((attendance) => attendance.manage_staff_id === staffId) || {};
        // const localAttendance = newAttendances.find((attendance) => attendance.manage_staff_id === staffId) || {};
        // const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
        // const formattedCurrentDate = `${currentDate.split('-')[2]}/${currentDate.split('-')[1]}`; // DD/MM

        // // Check server-side attendance data
        // const staffAttendance = attendanceData.find(staff => staff.staff_id === staffId);
        // if (staffAttendance && staffAttendance.attendance[formattedCurrentDate]) {
        //     const serverAttendance = staffAttendance.attendance[formattedCurrentDate];
        //     if (serverAttendance.type === 1) {
        //         return {
        //             attendance_type: 1,
        //             dates: [currentDate],
        //             leave_type: serverAttendance.leave_type_id,
        //             reason: serverAttendance.reason
        //         };
        //     }
        // }

        // return localAttendance;
    };
    
    const handleCheckboxChange = () => {
        checkIsChecked(!Checked);
    };
    const [Checked, checkIsChecked] = useState(false);

 
   // Handle form submission
    
    const handleRadioChange = (staffId, value) => {
        // console.log("Radio change for staffId:", staffId, "value:", value);
        setCurrentStaffId(staffId);
        if (value === 'present') {
            
            const attendanceEntry = {
                manage_staff_id: staffId,
                attendance_type: 0,
                branch_id: branch_id,
                date: new Date().toISOString().split('T')[0],
            };
            setNewAttendances((prev) => {
                
                const existingIndex = prev.findIndex(
                    (entry) => entry.manage_staff_id === staffId
                );
                if (existingIndex >= 0) {
                    return prev.map((entry, i) =>
                        i === existingIndex ? attendanceEntry : entry
                    );
                }
                return [...prev, attendanceEntry];
            });
        } else {
            // console.log("Opening modal for:", value, "staffId:", staffId);
            handleModalToggle(value === 'leave' ? 'Leave' : value === 'permission' ? 'Permission' : 'OD', staffId);
        }
    };

    // useEffect(() => {
    //     console.log("Updated newAttendances:", newAttendances);
    // }, [newAttendances]);

    const handleSubmit = () => {
    // Check if attendance exists for every staff in staffOptions
        // const allMarked = staffOptions.every(staff => 
        //     newAttendances.some(att => att.manage_staff_id === staff.id)
        // );

        if (!newAttendances.length) {
            swal.fire('Warning', 'No attendance data to submit.', 'warning');
            return;
        }

        // if (!allMarked) {
        //     swal.fire('Warning', 'Please mark attendance for all staff before submitting.', 'warning');
        //     return;
        // }

        axios
            .post(`${baseURL}/manageattendance`, { attendances: newAttendances })
            .then((response) => {
                toast.success("Attendance created successfully!");
                navigate('/manage-attendance');
            })
            .catch((error) => {
                toast.error(error.response?.data?.error || 'Failed to store attendance.');
            });
    };

    // Render attendance type
    const getAttendanceType = (type) => {
        switch (type) {
            case 0: return 'Present';
            case 1: return 'Leave';
            case 2: return 'Permission';
            case 3: return 'OD';
            default: return '-';
        }
    };

    
    const [selectedBranchOrFranchise, setSelectedBranchOrFranchise] = useState("present");
    const format = "MM/DD/YY";


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Add Attendance</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">HR Management</li>
                    </ol>
                </div>
                <div className='d-flex align-items-center gap-3 mb-2'>
                    <label className='fs-6 text-danger font-w600'>{(() => {
                        const date = new Date();
                        const day = String(date.getDate()).padStart(2, '0');
                        const month = date.toLocaleString('en-US', { month: 'short' });
                        const year = date.getFullYear();
                        return `${day}-${month}-${year}`;
                    })()}</label>
                    {open && modalType === "Permission" && (
                        <Permission show={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} staffId={currentStaffId}
                            staffOptions={staffOptions} existingData={getStaffAttendance(currentStaffId)}/>
                    )}
                    {open && modalType === "Absent" && (
                        <Absent show={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} />
                    )}
                    {open && modalType === "OD" && (
                        <OD show={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} staffId={currentStaffId}
                            staffOptions={staffOptions} existingData={getStaffAttendance(currentStaffId)} />
                    )}
                    {open && modalType === "Leave" && (
                        <Leave show={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} staffId={currentStaffId}
                            staffOptions={staffOptions} existingData={getStaffAttendance(currentStaffId)} />
                    )}


                </div>
            </div>
            <div className="table-container">
                <table ref={tableRef} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className='min-w-100px'>Staff</th>
                            <th className='min-w-100px text-start'>Attendance Type</th>
                            <th className='min-w-100px  text-start'>Duration</th>
                            <th className='min-w-100px  text-start'>Reason</th>
                            <th className='min-w-50px text-end'>Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {staffOptions.map((staff) => {
                            // console.log("Rendering row for:", staff.id, staff.name);
                            const attendance = getStaffAttendance(staff.id);
                            return (
                                <tr key={staff.id}>
                                    <td>
                                        <label className='text-black font-w400 fs-7'>{staff.name}</label>
                                        <div className='d-block'>
                                            <label className='text-gray-800 font-w400 fs-8'>{staff.department}</label>
                                        </div>
                                    </td>
                                    <td className='text-start'>
                                        
                                        <div className="form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name={`attendance-${staff.id}`}
                                                value="present"
                                                // defaultChecked
                                                checked={attendance?.attendance_type === 0}
                                                onChange={() => handleRadioChange(staff.id, 'present')}
                                            />
                                            <label className="form-check-label fs-7">
                                                Present
                                            </label>
                                        </div>
                                        <div className="form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name={`attendance-${staff.id}`}
                                                value="leave"
                                                checked={attendance?.attendance_type === 1}
                                                onChange={() => handleRadioChange(staff.id, 'leave')}
                                                // onClick={handleModalLeave}

                                            />
                                            <label className="form-check-label fs-7">
                                                Leave
                                            </label>
                                        </div>
                                        <div className="form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name={`attendance-${staff.id}`}
                                                value="permission"
                                                checked={attendance?.attendance_type === 2}
                                                onChange={() => handleRadioChange(staff.id, 'permission')}
                                                // onClick={handleModalPermission}
                                            />
                                            <label className="form-check-label fs-7">
                                                Permission
                                            </label>
                                        </div>
                                        <div className="form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name={`attendance-${staff.id}`}
                                                value="od"
                                                checked={attendance?.attendance_type === 3}
                                                onChange={() => handleRadioChange(staff.id, 'od')}
                                                // onClick={handleModalOD}

                                            />
                                            <label className="form-check-label fs-7">
                                                OD
                                            </label>
                                        </div>
                                    </td>
                                    <td className='text-start'>
                                        {/* - */}
                                        {attendance.attendance_type === 0 ? (
                                            <label className="text-success font-w600">-</label>
                                        ) : attendance.start_date || attendance.dates ? (
                                            <>
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>From Date</span></Tooltip>} >
                                            <label className='text-success font-w600'>{attendance.start_date || attendance.dates?.[0] || '-'}</label>
                                        </OverlayTrigger>
                                        <div className='d-block'>
                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>To Date</span></Tooltip>} >
                                                <label className='text-danger font-w600'>{attendance.end_date || attendance.dates?.[attendance.dates?.length - 1] || '-'}</label>
                                            </OverlayTrigger>
                                        </div>
                                        </>
                                    ) : (
                                    <label className="text-success font-w600">{attendance.date || '-'}</label>
                                    )}
                                    </td>
                                    <td className='text-start'>
                                        {/* - */}
                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{attendance.reason || '-'}</span></Tooltip>} >
                                            <label className='text-black fs-7 w-250px text-truncate'>{attendance.reason || '-'}</label>
                                        </OverlayTrigger>
                                    </td>
                                    <td className='text-end'>
                                        <span>
                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                <Link to={'#'} >
                                                    <Button variant="btn btn-primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle(
                                                            attendance.attendance_type === 1 ? 'Leave' :
                                                            attendance.attendance_type === 2 ? 'Permission' :
                                                            attendance.attendance_type === 3 ? 'OD' : 'Leave',
                                                            staff.id
                                                        )}>
                                                        <span><i className="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                                    </Button>
                                                </Link>
                                            </OverlayTrigger>
                                        </span>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                <Link to={'/manage-attendance'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                <button onClick={handleSubmit} type="submit" className="btn btn-sm btn-primary">Submit</button>
            </div>

        </>
    )


}
export default Add_Attendance;